import './JiraCredentialsUpdate.scss';
import { CloseOutlined } from '@ant-design/icons';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { JiraCredentialsForm } from './JiraCredentialsForm';
import { jiraIntegrationSelectors } from './@arch/selectors';
import { Button, FormInstance } from 'antd';
import { COPY_SPECIFIC, INTEGRATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useState } from 'react';
import { useAction, useCurrentUser, useSonarSelector } from '@hooks';

export interface JiraCredentialsUpdateProps {
	form: FormInstance<unknown>;
	onClose: () => void;
}

export const JiraCredentialsUpdate: React.FC<JiraCredentialsUpdateProps> = ({ form, onClose }) => {
	const [ disabled, setDisabled ] = useState(true);
	const isIntegrationRequested = useSonarSelector(jiraIntegrationSelectors.isRequested);
	const deleteJiraCredentials = useAction(integrationsActions.requestDeleteJiraCredentials);
	const { customerId } = useCurrentUser();

	const onSubmit = useCallback(() => {
		form.submit();
		onClose();
	}, [ form, onClose ]);

	const onCancel = useCallback(() => {
		form.resetFields();
		setDisabled(true);
		onClose();
	}, [ form, onClose ]);

	const onDelete = useCallback(() => {
		deleteJiraCredentials({ customerId });
		onClose();
	}, [ customerId, deleteJiraCredentials, onClose ]);

	const onUpdate = useCallback(() => {
		setDisabled(false);
	}, []);

	return (
		<div className='jira-popover'>
			<button
				className='popover-close'
				type='button'>
				<CloseOutlined onClick={ onCancel } />
			</button>
			<div className='jira-popover-header'>
				<div className='h3'>{ INTEGRATIONS_COPY.EDIT_JIRA_SETTINGS }</div>
			</div>
			<div className='jira-popover-body'>
				<JiraCredentialsForm
					form={ form }
					onUpdate={ onUpdate } />
			</div>
			<div className='jira-popover-footer'>
				<Button
					danger
					onClick={ onDelete }>
					{ COPY_SPECIFIC.DELETE_INTEGRATION }
				</Button>
				<div>
					<Button
						onClick={ onCancel }>
						{ COPY_SPECIFIC.CANCEL }
					</Button>
					<Button
						disabled={ disabled }
						id='update-jira-integration'
						loading={ isIntegrationRequested }
						onClick={ onSubmit }
						type='primary'>
						{ COPY_SPECIFIC.UPDATE }
					</Button>
				</div>
			</div>
		</div>
	);
};
